// INDEXES MULTIPLE ARBITRABLE TRANSACTION
export const BLOCKCHAIN_NON_TECHNICAL_MULTIPLE_ARBITRABLE_INDEX = 0
export const GENERAL_MULTIPLE_ARBITRABLE_INDEX = 1

export const KOVAN_MULTIPLE_ARBITRABLE_TRANSACTION_ADDRESSES = [
  '0x01171b3fb9627dd127a6ceb356b4470c492e7a8d', // Blockchain Non-Technical
  '0x23c8118ae9fb45a0cb7fcfe3af65d081233d82a5' // General Court
]

export const KOVAN_MULTIPLE_ARBITRABLE_TOKEN_TRANSACTION_ADDRESSES = [
  '0xdc73a27c2a81de8646937eac26fa34a870322874', // Blockchain Non-Technical
  '0xfe4fd3f2d4470fd032ee3e961a981b08e254a0d7' // General Court
]
// export const KOVAN_MULTIPLE_ARBITRABLE_TRANSACTION_ADDRESSES = [
//   '0x01171b3fb9627dd127a6ceb356b4470c492e7a8d', // Blockchain Non-Technical
//   '0x01171b3fb9627dd127a6ceb356b4470c492e7a8d' // General Court
// ]
//
// export const KOVAN_MULTIPLE_ARBITRABLE_TOKEN_TRANSACTION_ADDRESSES = [
//   '0xdc73a27c2a81de8646937eac26fa34a870322874', // Blockchain Non-Technical
//   '0xdc73a27c2a81de8646937eac26fa34a870322874' // General Court
// ]

export const MAINNET_MULTIPLE_ARBITRABLE_TRANSACTION_ADDRESSES = [
  '0xE2Dd8CCe2c33a04215074ADb4B5820B765d8Ed9D', // Blockchain Non-Technical
  '0x0d67440946949fe293b45c52efd8a9b3d51e2522' // General Court
]

export const MAINNET_MULTIPLE_ARBITRABLE_TOKEN_TRANSACTION_ADDRESSES = [
  '0xC25a0b9681ABF6F090AEd71a8c08fB564b41dab6', // Blockchain Non-Technical
  '0xBCf0d1AD453728F75e9cFD4358ED187598A45e6c' // General Court
]

// T2CR
export const KOVAN_T2CR_ADDRESS = '0x25dd2659a1430cdbd678615c7409164ae486c146'
export const MAINNET_T2CR_ADDRESS = '0xebcf3bca271b26ae4b162ba560e243055af0e679'
// ERC20
export const KOVAN_ERC20_BADGE_ADDRESS = '0x78895ec026aeff2db73bc30e623c39e1c69b1386'
export const MAINNET_ERC20_BADGE_ADDRESS = '0xcb4aae35333193232421e86cd2e9b6c91f3b125f'
// STABLECOIN
export const KOVAN_STABLECOIN_BADGE_ADDRESS = '0x0150a86c583764d85289895655d2e62473fa24c7'
export const MAINNET_STABLECOIN_BADGE_ADDRESS = '0xbc65204861f5776564fc3f61c04ec6ea8bea13be'
// TOKENSVIEW
export const KOVAN_TOKENS_VIEW_ADDRESS = '0xaef5648bb17d474369e1b1eb0c742ba8968a7acc'
export const MAINNET_TOKENS_VIEW_ADDRESS = '0xf9b9b5440340123b21bff1ddafe1ad6feb9d6e7f'
